// extracted by mini-css-extract-plugin
module.exports = {"defaultInput":"Form_defaultInput__45ORZ","button":"Form_button__2J9Yl","buttonWrapper":"Form_buttonWrapper__3lABk"};